<template>
  <template v-if="validatedProperty && nestedValidatedProperty">
    <div :class="['text-theme-6', 'top-full', 'whitespace-nowrap', position]">
      {{
        validationState[validatedProperty][nestedValidatedProperty].$errors[0]
          ?.$message
      }}
    </div>
  </template>
  <template v-else-if="validatedProperty">
    <div :class="['text-theme-6', 'top-full', 'whitespace-nowrap', position]">
      {{ validationState[validatedProperty].$errors[0]?.$message }}
    </div>
  </template>
  <template v-else>
    <div :class="['text-theme-6', 'top-full', 'whitespace-nowrap', position]">
      {{ validationState.$errors[0]?.$message }}
    </div>
  </template>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'VErrorMessage',
  props: {
    validationState: Object,
    validatedProperty: String,
    nestedValidatedProperty: String,
    position: {
      type: String,
      default: 'absolute'
    }
  }
})
</script>

<style scoped></style>
